import { PropsWithChildren } from 'react';
import cn from 'classnames';

interface SectionProps extends PropsWithChildren {
  typeSection?: 'section' | 'div';
  className?: string;
}

export const Section = ({ typeSection = 'div', className, children }: SectionProps) => {
  const WrapperSection = typeSection;

  return (
    <WrapperSection className={cn('rounded-3xl bg-white p-6', className)}>
      {children}
    </WrapperSection>
  );
};
